import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <header>
      <span>ConversionBoard3000™</span>
    </header>
  );
};

export default Header;
